import StepEmail from "@Front/Components/Layouts/Login/StepEmail";
import StepTotp from "@Front/Components/Layouts/Login/StepTotp";
import StepPassword from "@Front/Components/Layouts/Login/StepPassword";
import StepNewPassword from "@Front/Components/Layouts/Login/StepNewPassword";
import PasswordForgotten from "@Front/Components/Layouts/Login/PasswordForgotten";
import type { LoginControllerReturn } from "@Front/Components/Layouts/Login/hooks/useLoginController";

export function renderLoginCredentialEmailStep(controller: LoginControllerReturn): React.JSX.Element {
	return <StepEmail onSubmit={controller.onEmailFormSubmit} validationErrors={controller.validationErrors} />;
}

export function renderLoginCredentialTotpStep(controller: LoginControllerReturn): React.JSX.Element {
	return (
		<StepTotp
			onSubmit={controller.onSmsCodeSubmit}
			validationErrors={controller.validationErrors}
			partialPhoneNumber={controller.partialPhoneNumber}
			deliveryChannel={controller.deliveryChannel}
			maskedEmail={controller.maskedEmail}
			email={controller.email}
			onSendAnotherCode={controller.onSendAnotherCode}
			siteDisplayName={controller.siteDisplayName}
		/>
	);
}

export function renderLoginCredentialPasswordStep(controller: LoginControllerReturn): React.JSX.Element {
	return (
		<StepPassword
			onSubmit={controller.onPasswordSubmit}
			validationErrors={controller.validationErrors}
			onPasswordForgotClicked={controller.onPasswordForgotClicked}
			siteDisplayName={controller.siteDisplayName}
		/>
	);
}

export function renderLoginCredentialNewPasswordStep(controller: LoginControllerReturn): React.JSX.Element {
	return (
		<StepNewPassword
			onSubmit={controller.onNewPasswordSubmit}
			validationErrors={controller.validationErrors}
			siteDisplayName={controller.siteDisplayName}
		/>
	);
}

export function renderLoginCredentialPasswordForgottenStep(controller: LoginControllerReturn): React.JSX.Element {
	return (
		<PasswordForgotten
			onSubmit={controller.onNewPasswordSubmit}
			validationErrors={controller.validationErrors}
			siteDisplayName={controller.siteDisplayName}
		/>
	);
}
